import type { DocumentStatus } from '@/types'

// Status to Tailwind color class mapping
export const STATUS_COLORS: Record<DocumentStatus, string> = {
  new: 'bg-blue-100 text-blue-800',
  processing: 'bg-yellow-100 text-yellow-800',
  extracted: 'bg-green-100 text-green-800',
  validated: 'bg-emerald-100 text-emerald-800',
  reported: 'bg-gray-100 text-gray-800',
  invalid: 'bg-red-100 text-red-800',
  duplicate: 'bg-purple-100 text-purple-800',
  manual_review: 'bg-orange-100 text-orange-800',
}

// Human-readable status labels
export const STATUS_LABELS: Record<DocumentStatus, string> = {
  new: 'New',
  processing: 'Processing',
  extracted: 'Extracted',
  validated: 'Validated',
  reported: 'Reported',
  invalid: 'Invalid',
  duplicate: 'Duplicate',
  manual_review: 'Manual Review',
}

interface StatusBadgeProps {
  status: DocumentStatus
  className?: string
}

export function StatusBadge({ status, className = '' }: StatusBadgeProps) {
  const colorClass = STATUS_COLORS[status] || 'bg-gray-100 text-gray-800'
  const label = STATUS_LABELS[status] || status

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${colorClass} ${className}`}
      data-testid="status-badge"
      data-status={status}
    >
      {label}
    </span>
  )
}
